/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable no-tabs */
import { connect, useSelector } from 'react-redux';
import { useEffect } from 'react';
// import { ListTable } from '../../';
import { format } from 'date-fns';
import {
	addCommas,
	classes,
	convertToHigherUnit,
	getFileName,
	sanitizeCell,
	// higherUnits,
	useQuery,
} from '@/Helpers';
import styles from './BOMAnalysisListPage.module.scss';
import analyticsAction from '@/Actions/analytics.actions';
import { useAuth } from '@/Components/Auth/Login/auth';
import { ListTable } from '@/Components/ListTable';
// import { ArrangePages } from '../../../Components/Arrange Pages';

const TABLE_COLUMNS = [
	{
		title: 'Product Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'SKU Code',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'UY Variant ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Unit',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sub Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'SKU Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Rate per Kg/Pc/L',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Ideal Rate per Kg/Pc/L',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Left Over T-1 Qty',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Issued Qty',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Left Over Qty (T)',
		config: {
			type: 'DATA',
		},
	},
	{
		// title: 'Material QTY (Actual)',
		title: 'Net Issued Qty',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Net Issued Cost',
		config: {
			type: 'DATA',
		},
	},
	{
		// title: 'Ideal Quantity',
		title: 'Food Cost Ideal Qty',
		config: {
			type: 'DATA',
		},
	},
	{
		// title: 'Ideal Cost',
		title: 'Recipe Step Cost Ideal',
		config: {
			type: 'DATA',
		},
	},
	{
		// title: 'Ideal Cost',
		title: 'Ideal Food Cost',
		config: {
			type: 'DATA',
		},
	},
	{
		// Material QTY (Est.)
		title: 'Measured Inventory Consumed Qty',
		config: {
			type: 'DATA',
		},
	},
	{
		// title: 'Material QTY (Actual)',
		title: 'Gross Produced Qty',
		config: {
			type: 'DATA',
		},
	},
	{
		// Material QTY (Est.)
		title: 'Net Produced Qty',
		config: {
			type: 'DATA',
		},
	},
	{
		// Material COst (Est.)
		title: 'Measured Inventory Consumed Cost',
		config: {
			type: 'DATA',
		},
	},
	// {
	// 	// Material COst (Est.)
	// 	title: 'Net Produced Cost',
	// 	config: {
	// 		type: 'DATA',
	// 	},
	// },
	{
		title: 'Net Consumed Qty',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Net Consumed Cost',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Overfill / Underfill Qty',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Overfill / Underfill Cost',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Production Loss QTY (Est.)',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Production Loss (Est.)',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Excess Qty',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Excess Cost',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Wastage Qty',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Wastage Cost',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Total Cost',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Psc Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'qtyPre12',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'qtyPost12',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'workOrderId',
		config: {
			type: 'DATA',
		},
	},
];

const COLMAP = {
	'Psc Id': 'pks',
	'Product Name': 'productName',
	Unit: 'unit',
	Category: 'productCategoryName',
	'Sub Category': 'productSubcategoryName',
	'SKU Type': 'skuType',
	Store: 'storeName',
	'Rate per Kg/Pc/L': 'idealRate',
	'Ideal Rate per Kg/Pc/L': 'None',
	'Total Cost': 'bom_ingredient',
	'Issued Qty': 'issuedQty',
	'Gross Produced Qty': 'originalQty',
	'Net Issued Qty': 'netIssuedQty',
	'Net Issued Cost': 'netIssuedCost',
	'Left Over Qty (T)': 'leftOverQty',
	'Left Over T-1 Qty': 'leftOverTM1Qty',
	'Food Cost Ideal Qty': 'idealQty',
	'Ideal Food Cost': 'idealInvConsumed',
	'Measured Inventory Consumed Qty': 'measuredMaterialQty',
	'Net Produced Qty': 'qty',
	'Measured Inventory Consumed Cost': 'invConsumed',
	'Net Produced Cost': 'recipeCost',
	'Overfill / Underfill Qty': 'None',
	'Overfill / Underfill Cost': 'None',
	'Production Loss QTY (Est.)': 'productionLoss',
	'Production Loss (Est.)': 'productionLossCost',
	'Net Consumed Qty': 'None',
	'Net Consumed Cost': 'None',
	'Excess Qty': 'None',
	'Excess Cost': 'None',
	'Wastage Qty': 'None',
	'Wastage Cost': 'None',
	qtyPre12: 'qtyPre12',
	qtyPost12: 'qtyPost12',
	workOrderId: 'workOrderId',
	'Recipe Step Cost Ideal': 'idealInvConsumed',
	// 'Cost Category': 'costCategory',
};

const getRowStyles = (item) => {
	switch (item?.result) {
		default:
			return styles.normal;
	}
};

// function setAttr(text) {
// return <span className={styles.text}>{text}</span>;
// }

const BOMAnalysisListPage = (props) => {
	// const history = useHistory();
	const {
		data,
		setAnalyticsType,
		ANALYTICS_TYPE,
		analysisFilters,
		setAnalysisDashboardFilters,
	} = props;
	const { appConfig = {} } = useAuth();
	const { measurement } = appConfig?.configs || {};
	const queryParams = useQuery();
	const isProduct = analysisFilters?.analysisType === 'BOM';
	// eslint-disable-next-line no-unused-vars
	const selectedFilterType = queryParams.get('filterType');
	// const { appConfig = {} } = useAuth();
	// const { measurement } = appConfig?.configs ?? {};
	// const listCount = data.length - 1;
	const dateRange = useSelector((state) => state?.analytics?.DATE_RANGE_FILTER);
	useEffect(() => {
		setAnalysisDashboardFilters(
			{
				...analysisFilters,
				analysisType: 'BOM_INGREDIENT',
			},
			false
		);
		setAnalyticsType(ANALYTICS_TYPE, {});
	}, []);

	const SPECIAL_ITEMS = {
		'Product Name': (_, obj) => {
			// eslint-disable-next-line prefer-template
			return (obj?.productName + (obj?.variantName ? ' (' + obj?.variantName + ')' : ''));
		},
		'SKU Code': (_, obj) => {
			return obj?.clientVariantId;
		},
		'UY Variant ID': (_, obj) => {
			return obj?.variantId;
		},
		Unit: (unitValue) => {
			return convertToHigherUnit(unitValue)?.unit;
		},
		'Rate per Kg/Pc/L': (value, obj) => {
			if (
				obj?.qty === null ||
				obj?.qty === undefined
			) {
				return '-';
			}
			if (isProduct) {
				return addCommas(obj?.productRate, measurement, true);
			}
			return addCommas(value, measurement, true);
		},
		'Ideal Rate per Kg/Pc/L': (value, obj) => {
			// if (
			// 	obj?.qty === null ||
			// 	obj?.qty === undefined
			// ) {
			// 	return '-';
			// }
			return addCommas(obj?.idealRate, measurement, true);
			// if (isProduct) {
			// eslint-disable-next-line no-mixed-operators
			// return addCommas(
			// 	(obj?.recipeCostIdeal *
			// 		obj?.priceFactor *
			// 		higherUnits?.[obj?.unit]?.divideBy) /
			// 		obj.qty,
			// 	measurement,
			// 	true
			// );
			// }
			// return '-';
		},
		'Left Over T-1 Qty': (leftOverTM1Qty, obj) => {
			// eslint-disable-next-line max-len
			return convertToHigherUnit(
				obj?.unit,
				leftOverTM1Qty ?? 0
			)?.value?.toFixed(2);
		},
		'Issued Qty': (issuedQty, obj) => {
			// eslint-disable-next-line max-len
			return convertToHigherUnit(
				obj?.unit,
				issuedQty ?? 0
			)?.value?.toFixed(2);
		},
		'Left Over Qty (T)': (leftOverTQty, obj) => {
			// eslint-disable-next-line max-len
			return convertToHigherUnit(
				obj?.unit,
				leftOverTQty ?? 0
			)?.value?.toFixed(2);
		},
		'Gross Produced Qty': (qty, obj) => {
			// eslint-disable-next-line max-len
			return convertToHigherUnit(
				obj?.unit,
				qty ?? 0
			)?.value;
		},
		'Net Issued Qty': (netIssuedQty, obj) => {
			// eslint-disable-next-line max-len
			return convertToHigherUnit(
				obj?.unit,
				netIssuedQty ?? 0
			)?.value?.toFixed(2);
		},
		'Net Issued Cost': (value) => {
			return addCommas(value, measurement, true);
		},
		'Food Cost Ideal Qty': (idealQty, obj) => {
			// eslint-disable-next-line max-len
			return convertToHigherUnit(
				obj?.unit,
				idealQty ?? 0
			)?.value?.toFixed(2);
		},
		// eslint-disable-next-line no-unused-vars
		'Ideal Food Cost': (value, obj) => {
			if (isProduct) {
				if (obj?.bomRecipeCostIdeal < 0) {
					return addCommas(0, measurement);
				}
				return addCommas(obj?.bomRecipeCostIdeal, measurement, true);
			}
			return addCommas(value, measurement, true);
		},
		'Recipe Step Cost Ideal': (value, obj) => {
			return addCommas(value, measurement, true);
		},
		'Measured Inventory Consumed Qty': (value, obj) => {
			return convertToHigherUnit(obj?.unit, value ?? 0)?.value?.toFixed(
				2
			);
		},
		'Net Produced Qty': (value, obj) => {
			if (value < 0) {
				return addCommas(0, measurement);
			}
			if (obj?.unit === 'count') {
				return addCommas(value, measurement);
			}
			return convertToHigherUnit(obj?.unit, value ?? 0)?.value?.toFixed(
				2
			);
		},
		'Measured Inventory Consumed Cost': (value) => {
			return addCommas(value, measurement, true);
		},
		// 'Net Produced Cost': (value, obj) => {
		// 	if (value < 0) {
		// 		return addCommas(0, measurement);
		// 	}
		// 	if (isProduct) {
		// 		return addCommas(obj?.bomMeasuredCost, measurement, true);
		// 	}
		// 	return addCommas(value, measurement, true);
		// },
		'Net Consumed Qty': (_, obj) => {
			const value = obj?.originalQty - obj?.qty;
			if (value < 0) {
				return addCommas(0, measurement);
			}
			return convertToHigherUnit(obj?.unit, value)?.value?.toFixed(2);
		},
		'Net Consumed Cost': (_, obj) => {
			let value = obj?.productRate && obj?.productRate > 0 ? obj?.productRate * obj?.qty : (obj?.bomMeasuredCost * (obj?.originalQty - obj?.qty)) / (obj?.qty || 0);

			if (value === 0) {
				value = obj?.idealRate * (obj?.originalQty - obj?.qty);
			}
			if (obj?.unit !== 'count') {
				value /= 1000;
			}
			return addCommas(value, measurement, true);
		},
		'Overfill / Underfill Qty': (_, obj) => {
			// eslint-disable-next-line max-len
			return convertToHigherUnit(
				obj?.unit,
				(obj.measuredMaterialQty ?? 0) - (obj.idealQty ?? 0)
			)?.value?.toFixed(2);
		},
		'Overfill / Underfill Cost': (_, obj) => {
			if (isProduct) {
				return addCommas(
					obj.underOverfillCost,
					measurement,
					true
				);
			}
			return addCommas(
				obj.invConsumed - obj.idealInvConsumed,
				measurement,
				true
			);
		},
		'Wastage Qty': (_, obj) => {
			return convertToHigherUnit(obj?.unit, obj.wasteQty)?.value ?? 0;
		},
		'Wastage Cost': (_, obj) => {
			return addCommas(obj.wasteCost ?? 0, measurement, true);
		},
		'Excess Qty': (_, obj) => {
			if (!isProduct) {
				const lossQty = obj.productionLoss;
				if (lossQty < 0) {
					return convertToHigherUnit(obj?.unit, -lossQty)?.value?.toFixed(2);
				}
				return 0;
			}
			return 0;
			// let val = obj.qty - obj.netIssuedQty;
			// if (val < 0) val = 0;
			// return convertToHigherUnit(obj?.unit, val)?.value?.toFixed(2);
		},
		'Production Loss QTY (Est.)': (lossQty, obj) => {
			if (lossQty < 0) {
				return 0;
			}
			return convertToHigherUnit(obj?.unit, lossQty)?.value?.toFixed(2);
		},
		'Excess Cost': (_, obj) => {
			let val = obj.invConsumed - obj.netIssuedCost;
			if (val < 0) val = 0;
			return addCommas(val, measurement, true);
		},
		'Production Loss (Est.)': (value) => {
			if (value < 0) return 0;
			return addCommas(value, measurement, true);
		},
		'Total Cost': (value, obj) => {
			if (isProduct) {
				return addCommas(
					obj?.bom,
					measurement,
					true
				);
			}
			let totalCostIngredient = value;
			if (obj?.productionLossCost > 0) {
				totalCostIngredient = value + obj?.productionLossCost;
			}
			return addCommas(totalCostIngredient, measurement, true);
		},
		'Inventory Issued Cost': (value) => {
			return addCommas(value, measurement, true);
		},
		Wastage: (value) => {
			return addCommas(value, measurement, true);
		},
		'Psc Id': (value) => {
			return value;
		},
		qtyPre12: (value, obj) => {
			if (value < 0) {
				return 0;
			}
			return convertToHigherUnit(obj?.unit, value)?.value?.toFixed(2);
		},
		qtyPost12: (value, obj) => {
			if (value < 0) {
				return 0;
			}
			return convertToHigherUnit(obj?.unit, value)?.value?.toFixed(2);
		},
		workOrderId: (value) => {
			return value;
		},
	};

	const exludedColumns = [
		// 'Left Over T-1 Qty',
		'Issued Qty',
		// 'Left Over Qty (T)',
		'Net Issued Qty',
		'Net Issued Cost',
		'Food Cost Ideal Qty',
		'Production Loss QTY (Est.)',
		'Excess Qty',
		'Excess Cost',
		'Overfill / Underfill Qty',
		'Measured Inventory Consumed Qty',
		'Measured Inventory Consumed Cost',
	];

	const handleExportClick = () => {
		const leftOverQtyIndex = TABLE_COLUMNS.findIndex((column) => column.title === 'Left Over Qty (T)');
		const newColumns = [
			{
				title: 'leftOverQtyDate',
				config: {
					type: 'DATA',
				},
			},
			{
				title: 'leftOverTM1QTYDate',
				config: {
					type: 'DATA',
				},
			},
		];
		const updatedTableColumns = [
			...TABLE_COLUMNS.slice(0, leftOverQtyIndex + 1),
			...newColumns,
			...TABLE_COLUMNS.slice(leftOverQtyIndex + 1),
		];
		const headers = [...updatedTableColumns]
			.filter((ele) => {
				if (!isProduct) {
					return ![
						'qtyPre12',
						'qtyPost12',
						'Recipe Step Cost Ideal',
						'workOrderId',
						'Gross Produced Qty',
						'Net Produced Qty',
						'Ideal Rate per Kg/Pc/L',
						'Net Consumed Qty',
						'Net Consumed Cost',
						'Psc Id',
					].includes(ele?.title);
				}
				return !exludedColumns.includes(ele?.title);
			})
			.map((ele) => ele.title);

		const descriptionRow = Array(14).fill('-');
		// Second row: description (for demo, just a string, you can customize as needed)
		if (isProduct) {
			descriptionRow.push('Ideal Food Cost of ingredients in last step');
			descriptionRow.push('Ideal Food Cost if SFG is made on same day');
			descriptionRow.push('Quantity Scanned on machine');
			descriptionRow.push('Quantity Scanned - Used in production on same day');
			descriptionRow.push('Total Quantity consumed in Parent');
			descriptionRow.push('Cost of consumed quantity');
			descriptionRow.push('Amount of extra or under weight cost as per scanning');
			descriptionRow.push('Amount of ingredient missing');
			descriptionRow.push('Declared Wastage Qty');
			descriptionRow.push('Declared Wastage Amount');
			descriptionRow.push('measured inventory +  production loss');
			descriptionRow.push('Unique ID for variant+store+day');
			descriptionRow.push('Quantity scanned Before 12 am');
			descriptionRow.push('Quantity scanned After 12 am');
			descriptionRow.push('Work Order of Machine');
		} else {
			descriptionRow.push('Quantity Issued - leftOver');
			descriptionRow.push('Quantity Issued - leftOver Cost');
			descriptionRow.push('Ideal Inventory Required');
			descriptionRow.push('Ideal Inventory Required Cost');
			descriptionRow.push('Measured Inventory Consumed as per Scanning');
			descriptionRow.push('Measured Inventory Consumed as per Scanning Cost');
			descriptionRow.push('Overweight/Underweight Inventory Used as per Scanning');
			descriptionRow.push('Overweight/Underweight Inventory Used as per Scanning Cost');
			descriptionRow.push('Estimated Production loss Qty');
			descriptionRow.push('Estimated Production loss Cost');
			descriptionRow.push('Estimated Excess Found Qty');
			descriptionRow.push('Estimated Excess Found Cost');
			descriptionRow.push('Wastage declared in kitchen');
			descriptionRow.push('Wastage declared in kitchen Cost');
			descriptionRow.push('Net Inventory Issued + Production loss');
		}
		// Prepare data rows
		const dataRows = data?.map((item) => headers.map((header) => {
			if (header === 'leftOverQtyDate') {
				return item?.leftOverQtyDate;
			}
			if (header === 'leftOverTM1QTYDate') {
				return item?.leftOverTM1QTYDate;
			}
			const colKey = COLMAP[header];
			const specialFn = SPECIAL_ITEMS[header];
			const rawValue = specialFn ? specialFn(item[colKey], item) : item[colKey] ?? '-';
			return sanitizeCell(rawValue);
		}));

		const exportData = [headers, descriptionRow, ...dataRows];
		const csvContent = `\uFEFF${exportData.map((row) => row.join(',')).join('\n')}`;
		const csvFile = new Blob([csvContent], {
			type: 'text/csv;charset=utf-8;',
		});
		const name = isProduct ? 'Product/Intermediate' : 'Ingredient';
		const downloadLink = document.createElement('a');
		downloadLink.download = `${name}-${format(dateRange?.from, 'yyyy-MM-dd')}_to_${format(dateRange?.to, 'yyyy-MM-dd')}.csv`;
		downloadLink.href = URL.createObjectURL(csvFile);
		document.body.appendChild(downloadLink);
		downloadLink.click();
		URL.revokeObjectURL(downloadLink.href);
		document.body.removeChild(downloadLink);
	};

	return (
		<div className={classes(styles.root, 'list-page-root')}>
			<ListTable
				fixedHeaderTop={0}
				hasDateRange
				showTotal
				colMap={COLMAP}
				special={SPECIAL_ITEMS}
				data={data?.map((obj) => {
					const rowStyles = getRowStyles(obj);
					// const itemId = get(obj, COLMAP['Item Id']);
					// const qc = get(obj, COLMAP.qc);
					return {
						...obj,
						rowStyles,
					};
				})}
				columns={[...TABLE_COLUMNS]?.filter((ele) => {
					if (!isProduct) {
						return ![
							// 'Net Produced Cost',
							'qtyPre12',
							'qtyPost12',
							'Recipe Step Cost Ideal',
							'workOrderId',
							'Psc Id',
							'Gross Produced Qty', 'Net Produced Qty', 'Ideal Rate per Kg/Pc/L', 'Net Consumed Qty', 'Net Consumed Cost']?.includes(
							ele?.title
						);
					}
					return !exludedColumns?.includes(ele?.title);
				})}
				actions={[]}
				onExportClick={handleExportClick}
			/>
			{/* <ArrangePages
				listCount={61}
				ANALYTICS_TYPE={ANALYTICS_TYPE}
				setAnalyticsType={setAnalyticsType}
			/> */}
		</div>
	);
};

const mapStateToProps = (state) => {
	const { ANALYSIS_DASHBOARD_FILTERS } = state.analytics;
	return {
		analysisFilters: ANALYSIS_DASHBOARD_FILTERS,
	};
};
const mapDispatchToProps = {
	setAnalyticsType: analyticsAction.setAnalyticsType,
	setAnalysisDashboardFilters: analyticsAction.setAnalysisDashboardFilters,
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(BOMAnalysisListPage);
